import React from "react";

export const MediaLoadPriorityContext = React.createContext<number>(0);
